import { Popover, PopoverProps, PopoverBody } from 'reactstrap';

import { TFeature, FEATURE } from 'services/constants';

type PopoverMessageByFeature = {
     
    [key in TFeature]?: string;
}

export const featureDescriptions: PopoverMessageByFeature = {
    [FEATURE.PORTFOLIO_COST_ANALYTICS]: 'Aggregate and analyze budget line cost benchmarks and spending histories across multiple projects.',
    [FEATURE.QUICK_ANALYTICS]: 'Compare portfolio cost and performance benchmarks by asset class, project type, geography and more.',
    [FEATURE.PORTFOLIO_VENDOR_ANALYTICS]: 'Aggregate and analyze vendors invoices, contracts, and change order data across multiple projects.',
    [FEATURE.GLOBAL_COST_FORECAST]: 'Aggregate actual and forecasted costs by budget line across a portfolio of projects.',
    [FEATURE.VENDOR_DIRECTORY]: `Have full visibility across your entire vendor base with Northspyre's Vendor Directory,
        a company-wide, live vendor database where your team can catalog key vendor insights.`,
    [FEATURE.PORTFOLIO_INVOICE_DATA_INDEX]:
        'Have full visibility of all of your portfolio’s invoices and manage invoices across all projects in a single view.',
    [FEATURE.PORTFOLIO_BUDGET_CATEGORIZATIONS]:
            'Have full visibility of all of your portfolio’s budget categorizations in a single view.',
};

export const PORTFOLIO_OR_ORGANIZATION_LVL_POPOVERS: PopoverMessageByFeature = {
    [FEATURE.PORTFOLIO_COST_ANALYTICS]: featureDescriptions[FEATURE.PORTFOLIO_COST_ANALYTICS],
    [FEATURE.PORTFOLIO_VENDOR_ANALYTICS]: featureDescriptions[FEATURE.PORTFOLIO_VENDOR_ANALYTICS],
    [FEATURE.QUICK_ANALYTICS]: featureDescriptions[FEATURE.QUICK_ANALYTICS],
    [FEATURE.GLOBAL_COST_FORECAST]: featureDescriptions[FEATURE.GLOBAL_COST_FORECAST],
    [FEATURE.VENDOR_DIRECTORY]: featureDescriptions[FEATURE.VENDOR_DIRECTORY],
    [FEATURE.PORTFOLIO_INVOICE_DATA_INDEX]: featureDescriptions[FEATURE.PORTFOLIO_INVOICE_DATA_INDEX],
    [FEATURE.PORTFOLIO_BUDGET_CATEGORIZATIONS]: featureDescriptions[FEATURE.PORTFOLIO_BUDGET_CATEGORIZATIONS],
};

export interface IProps {
    toggle: (arg?: any) => void;
    isOpen: boolean;
    placement?: PopoverProps['placement'];
    trigger?: string;
    target: string;
    feature: TFeature;
    upgradeTier: string;
}

const FeatureTierPopover
 = ({
     toggle,
     isOpen,
     placement,
     trigger,
     target,
     feature,
     upgradeTier,
 }: IProps) => {
     const title = `You've reached a Northspyre ${upgradeTier} feature`;
     const message = PORTFOLIO_OR_ORGANIZATION_LVL_POPOVERS[feature];

     return (
         <Popover
             placement={placement}
             isOpen={Boolean(isOpen && title && !!message)}
             target={target}
             toggle={toggle}
             trigger={trigger}
             id={`${target}-popover`}
         >
             <PopoverBody>
                 <b>{title}</b>
                 <p className="my-2">{message}</p>
                 <span className="font-italic">
                     Contact your org admin for more details
                 </span>
             </PopoverBody>
         </Popover>
     );
 };

FeatureTierPopover.defaultProps = {
    placement: 'auto',
    trigger: 'focus',
};

export default FeatureTierPopover;
